export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-2.3aaf00c5.png";